<template>
  <div
    class="wf-relative"
    :class="editorClasses"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <video
      v-if="background == 'video'"
      :poster="videoPoster"
      style="height: 100%; width: 100%; position: absolute; top: 0px"
      class="video-js"
      id="my-player"
    ></video>
    <!-- <div class="video-background">
      <div class="video-foreground">
        <iframe
            src="https://www.youtube.com/embed/W0LHTWG-UmQ?controls=0&showinfo=0&rel=0&autoplay=1&loop=1"
            frameborder="0"
            allowfullscreen
        ></iframe>
      </div>
    </div> -->
    <div
      :id="$vnode.key"
      :ref="$vnode.key"
      :class="elementClasses"
      :style="elementStyles"
    >
      <draggable
        v-model="rows"
        group="rows"
        handle=".row-handle"
        class="wf-w-full"
      >
        <EditorRow
          @mouseover="childHover = true"
          @mouseleave="childHover = false"
          v-for="row in rows"
          :key="row.id"
        />
      </draggable>
    </div>
    <EditorOptions
      parent="section"
      v-show="hover && ! childHover && ! previewMode"
      :options="menuOptions"
    />
  </div>
</template>

<script>
  import EditorRow from './EditorRow'
  import { ConstantsParser } from '../ConstantsParser'
  import EditorElement from '../contracts/EditorElement'
  export default EditorElement.extend({
    components: {EditorRow},
    data() {
      return {
        videoPlayer: null,
      }
    },
    watch: {
      video(value) {
        if (! value || this.background != 'video') {
          return
        }
        if (! this.videoPlayer) {
          return this.$nextTick(() => this.videoPlayer = this.initVideoPlayer())
        }
        this.videoPlayer.src(this.videoSrc)
        this.videoPlayer.load()
        this.videoPlayer.play()
      },
      parallax() {
        this.toggleParallax()
      },
    },
    computed: {
      elementClasses() {
        if (this.previewMode) {
          return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(this.classes, this.device)).parse()]
        }
        let displayClasses = []
        let classes = Object.keys(this.classes).reduce((carry, device) => {
          let deviceDisplayClass = this.classes[device].find(deviceClass => deviceClass.property == 'Display')
          if (deviceDisplayClass) {
            let opacity = 'wf-opacity-100'
            let prefix = ''
            if (device === 'tablet') {
              prefix = 'sm:'
            }
            if (device === 'desktop') {
              prefix = 'lg:'
            }
            if (deviceDisplayClass.value == 'NONE') {
              opacity = 'wf-opacity-50'
            }
            displayClasses.push(`${prefix}${opacity}`)
          }
          let deviceObject = {}
          let deviceClasses = this.classes[device].filter(deviceClass => deviceClass.property != 'Display')
          this.$set(deviceObject, device, deviceClasses)
          return {...carry, ...deviceObject}
        }, {})
        return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(classes, this.device)).parse(), ...displayClasses]
      },
      module() {
        return 'sectionModule'
      },
      family() {
        return 'sections'
      },
      sectionIndex() {
        return this.$store.getters[`${this.module}/index`](this.id)
      },
      parent() {
        return this.$parent.$parent
      },
      background() {
        return this.$store.getters[`${this.module}/background`](this.element)
      },
      styles() {
        return this.$store.getters[`${this.module}/styles`](this.element)
      },
      properties() {
        return this.$store.getters[`${this.module}/properties`](this.element)
      },
      classes() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'classes')
      },
      assets() {
        return this.$store.getters['sectionModule/assets'](this.element)
      },
      video() {
        if (this.background != 'video') {
          return null
        }
        let video = this.assets.find(asset => Object.prototype.hasOwnProperty.call(asset, 'video'))
        return video ? video : null
      },
      videoPoster() {
        return this.video ? this.video.poster : ''
      },
      videoSrc() {
        if (! this.video) {
          return
        }
        let src = {src: this.video.video}
        let pattern = /youtu(be\.com|\.be)/g
        if (pattern.test(this.video)) {
          this.$set(src, 'type', "video/youtube")
        }
        return src
      },
      rows: {
        get() {
          return this.$store.getters['rowModule/elements'](this.element)
        },
        set(value) {
          this.$store.dispatch('rowModule/updateOrder', {section: this.sectionIndex, value})
        }
      }
    },

    methods: {
      initVideoPlayer() {
        return window.videojs.default('my-player', {
          autoplay: true,
          techOrder: ['youtube', 'html5'],
          controls: false,
          preload: 'auto',
          loop: true,
          muted: true,
          sources: [this.videoSrc],
          youtube: {
            origin: 'http://htmleditor.test',
            loop: 1,
            autoplay: 1,
            controls: 0,
            disablekb: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel:0
          },
        })
      },
      // toggleParallax() {
      //  if(this.parallax) {
      //      return window.addEventListener('scroll', this.activateParallax)
      //  }
      //  this.$refs[this.$vnode.key].style['background-position-y'] = 'top'
      //  return window.removeEventListener('scroll', this.activateParallax)
      // },

      // activateParallax() {
      //  let parallaxEffect = `${-(window.pageYOffset * .5)}px`
      //  this.$refs[this.$vnode.key].style['background-position-y'] = parallaxEffect
      // },
    }
  })
</script>

<style>
  .vjs-modal-dialog-content, .vjs-error-display.vjs-modal-dialog {
    display: none;
  }
  .vjs-tech {
    object-fit: cover;
  }
  * { box-sizing: border-box; }
  /*.video-ba ckground {
    background: #000;
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: -99;
  }
  .video-foreground,
  .video-background iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  #vidtop-content {
    top: 0;
    color: #fff;
  }
  .vid-info { position: absolute; top: 0; right: 0; width: 33%; background: rgba(0,0,0,0.3); color: #fff; padding: 1rem; font-family: Avenir, Helvetica, sans-serif; }
  .vid-info h1 { font-size: 2rem; font-weight: 700; margin-top: 0; line-height: 1.2; }
  .vid-info a { display: block; color: #fff; text-decoration: none; background: rgba(0,0,0,0.5); transition: .6s background; border-bottom: none; margin: 1rem auto; text-align: center; }
  @media (min-aspect-ratio: 16/9) {
    .video-foreground { height: 300%; top: -100%; }
  }
  @media (max-aspect-ratio: 16/9) {
    .video-foreground { width: 300%; left: -100%; }
  }
  @media all and (max-width: 600px) {
  .vid-info { width: 50%; padding: .5rem; }
  .vid-info h1 { margin-bottom: .2rem; }
  }
  @media all and (max-width: 500px) {
  .vid-info .acronym { display: none; }
  }*/
</style>